module.exports = __webpack_public_path__ + "static/media/webdesign-services-img18.b8d7b4eb.jpg";